const URL = {
  DASHBOARD_GET_PARTICIPANTS: 'DashBoard/GetParticipantsPage',
  DASHBOARD_GET_ENGAGEMENT: 'Dashboard/GetEngagementPage',
  DASHBOARD_GET_ITEMS_COMPLETED: 'Dashboard/GetItemsCompletedPage',
  DASHBOARD_ACTIVE_USER_LINE_SERIES: 'Dashboard/GetTimelyResults',
}

export default URL
